import { useFeatureFlag } from 'featureFlags/hooks/useFeatureFlag'
import { FeatureFlag } from 'shared/enums/FeatureFlag'
import { useGetRafflesQuery } from 'api/rafflesApi'
import { RafflePanel } from './RafflePanel'
import { isRaffleVisible } from './raffleUtils'

interface IRafflePdpModuleProps {
  productSlug: string
}

export const RafflePdpModule = ({ productSlug }: IRafflePdpModuleProps) => {
  const isRafflesEnabled = useFeatureFlag(FeatureFlag.TEMP_WEB_FC_ENABLE_RAFFLES)
  const { data: raffles } = useGetRafflesQuery(undefined, {
    skip: !isRafflesEnabled,
  })

  if (!isRafflesEnabled || !raffles) return null

  /* Show the PDP module while the raffle is open (active) and also
     in the lead-up window (upcoming). The panel itself adapts its
     status copy and countdown target to the raffle status. */
  const raffle = raffles.find(
    (r) => (r.productSlug || r.slug) === productSlug && isRaffleVisible(r),
  )

  if (!raffle) return null

  return <RafflePanel raffle={raffle} variant="pdp" />
}
